import { combineReducers } from "redux";
// import storage from "redux-persist/lib/storage";
import network from "./network/reducer";
import token from "./token/reducer";
import search from "./search/reducer";
import signup from "./signup/reducer";
import login from "./login/reducer";
import user from "./user/reducer";
import notification from "./notification/reducer";
import externalProfile from "./externalProfile/reducer";
import action from "./action/reducer";
import ranking from "./ranking/reducer";
import team from "./team/reducer";
import nav from "./nav/reducer";
import historical from "./historical/reducer";
import profileSettings from "./profileSettings/reducer";
import feeling from "./feeling/reducer";
import message from "./message/reducer";
import randomCoffee from "./randomCoffee/reducer";
import glossary from "./glossary/reducer";
import idea from "./idea/reducer";
import poll from "./poll/reducer";
import userCampaign from "./userCampaign/reducer";
import library from "./library/reducer";
import client from "./client/reducer";
import survey from "./survey/reducer";
import realTime from "./realTime/reducer";
import coaching from "./coaching/reducer";
import resources from "./resources/reducer";
import upload from "./upload/reducer";
import general from "./general/reducer";

export const allReducersName = [
  "token",
  "signup",
  "historical",
  "login",
  "user",
  "ranking",
  "team",
  "notification",
  "network",
  "externalProfile",
  "profileSettings",
  "action",
  "feeling",
  "nav",
  "search",
  "message",
  "randomCoffee",
  "glossary",
  "idea",
  "poll",
  "userCampaign",
  "realTime",
  "client",
  "survey",
  "coaching",
  "resources",
  "upload",
  "general"
];

const rootReducer = combineReducers({
  token,
  signup,
  historical,
  login,
  user,
  nav,
  ranking,
  team,
  notification,
  network,
  externalProfile,
  profileSettings,
  action,
  feeling,
  search,
  message,
  randomCoffee,
  glossary,
  idea,
  poll,
  userCampaign,
  library,
  client,
  survey,
  realTime,
  coaching,
  resources,
  upload,
  general
});

export default rootReducer;

export type AppState = ReturnType<typeof rootReducer>;
